export enum ESupportTabs {
  CLIENTS = 'clients',
  VERIFICATIONS = 'verifications',
}

export const SUPPORT_TABS = Object.values(ESupportTabs);
